<template>
  <v-list-item v-bind="$attrs" v-on="$listeners">
    <slot />
  </v-list-item>
</template>

<script>
export default {
  name: "BaseListItem",
};
</script>
